<template>
  <v-container grid-list-md class="app-container" v-if="this.$store.getters.programsFetched">
    <v-layout row>
      <h1>{{ $t('message.dealerAppHeader') }}</h1>
      <v-spacer></v-spacer>
      {{ $t('message.lastUpdateDate') }}:

      {{ formatDate(this.$store.getters.getDealerApplication.lastUpdateDate) }}

      <br />
      Application Id: {{ this.$store.getters.getDealerApplication.id }}
    </v-layout>

    <p v-html="$t('message.dealerAppInfoSubmitted')"></p>

    <v-card flat xs24 sm12>
      <finalize></finalize>
    </v-card>

    <applicant v-show="false"></applicant>
    <owners v-show="false"></owners>
    <store-locations v-show="false"></store-locations>
    <ach-info v-show="false"></ach-info>
  </v-container>
</template>

<script>
import Applicant from './Application/Applicant'
import Owners from './Application/Owners'
import StoreLocations from './Application/StoreLocations'
import AchInfo from './Application/AchInfo'
import Finalize from './Application/Finalize'

export default {
  data() {
    return {
      showSuccess: false,
      showError: false,
      required: ''
    }
  },
  methods: {
    onNextTab() {
      if (this.currentTab < 5) {
        this.currentTab += 1
      }
    },
    onPrevTab() {
      if (this.currentTab > 0) {
        this.currentTab -= 1
      }
    }
  },
  components: {
    applicant: Applicant,
    owners: Owners,
    'store-locations': StoreLocations,
    'ach-info': AchInfo,
    finalize: Finalize
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SubmittedApplication.vue